import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { getPDSSegmentsService } from "services/admin/productService";
import { setPDSSegments } from "redux/slices/admin/productSlice";
import { createCredPaymentServiceSegmentsService, deleteCredPaymentServiceSegmentsService } from "services/admin/providerService";
import { setPaymentServiceSegments } from "redux/slices/admin/providerSlice";
import { Grid } from "@mui/material";

const CredPDSSegmentScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    providerCredSelected,
    paymentServiceSegments,
  } = useSelector((store) => store.providers);
  const {
    pdsSegments
  } = useSelector((state) => state.products);


  useEffect(() => {
    getPDSSegmentsService()
      .then((data) => dispatch(setPDSSegments(data)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async ({ id }, currentValue) => {
    (currentValue ?
      deleteCredPaymentServiceSegmentsService(providerCredSelected.id, id) :
      createCredPaymentServiceSegmentsService(providerCredSelected.id, id)
    ).then((result) => {
      dispatch(setPaymentServiceSegments(result));
    }).catch(error => errorAlert(error))
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="commerce">Segmentos</div>
        </div>
        <div>
        </div>
      </Grid>
      <TableData
        dataRows={pdsSegments.map((item) => {
          const find = paymentServiceSegments.find(({ idSegment }) => idSegment.id === item.id);
          return { ...item, state: find ? true : false };
        })}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default CredPDSSegmentScreen;
